export const SUBMISSION_STATUS = {
  '-1': 'Pending',
  '0': 'Accepted',
  '1': 'Wrong Answer',
  '2': 'Compile Error',
  '3': 'Time Limit Exceed',
  '4': 'Memory Limit Exceed',
  '5': 'Runtime Error',
  '6': 'Judge Error',
  '7': 'Output Limit Exceed',
}

export const SUBMISSION_COLOR = {
  '-1': '#9e675a',
  '0': '#00C853',
  '1': '#F44336',
  '2': '#DD2C00',
  '3': '#9c56a8',
  '4': '#FF9800',
  '5': '#2196F3',
  '6': '#a65a5c',
  '7': '#BF360C',
}

export const SUBMISSION_STATUS_CODE = {
  PENDING: -1,
  ACCEPTED: 0,
  WRONG_ANSWER: 1,
  COMPILE_ERROR: 2,
  TIME_LIMIT_EXCEED: 3,
  MEMORY_LIMIT_EXCEED: 4,
  RUNTIME_ERROR: 5,
  JUDGE_ERROR: 6,
  OUTPUT_LIMIT_EXCEED: 7,
}
